import { render } from "./SideBarNavigation.vue?vue&type=template&id=22c483e4"
import script from "./SideBarNavigation.vue?vue&type=script&lang=js"
export * from "./SideBarNavigation.vue?vue&type=script&lang=js"

import "./SideBarNavigation.vue?vue&type=style&index=0&id=22c483e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__